import InputField from "components/fields/InputField";
import { FcGoogle } from "react-icons/fc";
import Checkbox from "components/checkbox";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import Toast from "components/toaster";
import { useDispatch } from "react-redux";
import Auth from "../../store/slice/auth";
import { useState } from "react";
import Loader from "../../assets/img/loader.gif";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

export default function SignIn() {
  const auth = Auth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object().shape({
      email: yup.string().email().required("Please Enter Email"),
      password: yup.string().required("Please Enter Password"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const { email, password } = values;
        await dispatch(auth.login({ email, password })).unwrap();
        navigate("/users");
        window.location.reload();
        Toast("success", "Login Successfully!");
      } catch (error) {
        const message =
          error?.message || error?.apierror?.message || error?.error || error?.data?.message || error?.response?.data?.message || "Login failed";
        Toast("error", message);
      } finally {
        setIsLoading(false);
      }
    },
  });

  const handleChangePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="mx-10 flex h-full min-h-screen w-full items-center justify-center px-2 md:mx-0 md:px-0">
      {/* Sign in section */}
      <div className="w-full max-w-full flex-col items-center rounded-xl border border-white/10 p-5 md:max-w-[420px]">
        <form onSubmit={formik.handleSubmit}>
          <h4 className="mb-2.5 text-4xl font-bold text-white">Sign In</h4>
          <p className="mb-9 ml-1 text-base text-gray-600">
            Enter your email and password to sign in!
          </p>

          {/* Email */}
          <div className="mb-3">
            <InputField
              variant="auth"
              extra="mb-2"
              label="Email*"
              placeholder="mail@simmmple.com"
              id="email"
              type="text"
              name="email"
              onChange={formik.handleChange}
              values={formik.values.email}
            />
            {formik.touched.email && formik.errors.email && (
              <p className="validation-error">{formik.errors.email}</p>
            )}
          </div>

          {/* Password */}
          <div className="relative mb-3">
            <InputField
              variant="auth"
              extra="mb-2"
              label="Password*"
              placeholder="Password"
              id="password"
              type={showPassword ? "text" : "password"}
              name="password"
              onChange={formik.handleChange}
              values={formik.values.password}
            />
            {showPassword ? (
              <IoMdEye
                onClick={handleChangePassword}
                className="absolute right-3 top-12 cursor-pointer text-white"
              />
            ) : (
              <IoMdEyeOff
                onClick={handleChangePassword}
                className="absolute right-3 top-12 cursor-pointer text-white"
              />
            )}
            {formik.touched.password && formik.errors.password && (
              <p className="validation-error">{formik.errors.password}</p>
            )}
          </div>
          {/* Checkbox */}

          <button
            type="submit"
            className="linear mt-2 flex w-full items-center justify-center rounded-xl bg-orangePrimary py-[12px] text-base font-medium text-white transition duration-200 hover:bg-orangePrimary/80 active:bg-orangePrimary/80"
          >
            {isLoading ? (
              <img src={Loader} alt="Loader" className="h-6 w-6" />
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
